export default {
    company: {
        name: "Verictas",
        logo: "/Verictas.png",
        color: "#3498db"
    },
    apiUrl: "https://api.crm.verictas.com",
    paymentToken: "pk_live_5G1sNtauxbLuJGK45gXnWd0P"
}